// extracted by mini-css-extract-plugin
export default {"checkbox-group-list-item":"checkbox-group_checkbox-group-list-item__WKIyT"};